import React, { useLayoutEffect } from 'react';
import { useThree } from '@react-three/fiber';
import { getFabVisualConfig } from '../../utils/fabVisualConfig';
import { createFabDebugOverrideMaterial } from '../../utils/fabDebugMaterial';

/**
 * Parts 59–61 — neutral geometry / material / glass debug comparison modes.
 * Uses scene.overrideMaterial so production kits stay unchanged.
 */
export const FabDebugSceneOverride: React.FC = () => {
  const { scene } = useThree();
  const { debugMaterialMode, referenceGeometryMode } = getFabVisualConfig();
  const mode = referenceGeometryMode ? 'neutral' : debugMaterialMode;

  useLayoutEffect(() => {
    if (!mode) {
      scene.overrideMaterial = null;
      return;
    }
    const mat = createFabDebugOverrideMaterial(mode);
    scene.overrideMaterial = mat;
    return () => {
      scene.overrideMaterial = null;
      mat.dispose();
    };
  }, [mode, scene]);

  return null;
};

export default FabDebugSceneOverride;
